<template>
  <h3 :class="['category-title', className]">
    <div
      v-if="defaultIcon"
      class="icon-container"
    >
      <FirstDraftStars />
    </div>
    <div
      v-else-if="atsToUse"
      class="icon-container"
    >
      <DpplSvg
        :file-name="atsToUse"
      />
    </div>
    {{ title }}
    <FilterInfoTooltip
      v-if="tooltip.body_r"
      :tooltip="tooltip"
    />
  </h3>
</template>

<script setup>
import { computed } from 'vue';
import DpplSvg from '@/components/datapeople/DpplSvg.vue';
import FilterInfoTooltip from '@/components/filter/FilterInfoTooltip.vue';
import {
  SMARTRECRUITERS, GREENHOUSE, GR8PEOPLE, LEVER, WORKDAY, SUCCESSFACTORS, ICIMS,
} from '@/helpers/constants/atsIds';
import FirstDraftStars from '@ui/assets/icons/First_Draft_Stars.svg?component';

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  atsId: {
    type: Number,
    default: 28,
  },
  className: {
    type: String,
    default: '',
  },
  defaultIcon: {
    type: Boolean,
    default: false,
  },
  tooltip: {
    type: Object,
    default: () => ({}),
  },
});

const atsIds = {
  [GREENHOUSE]: 'greenhouse',
  [SMARTRECRUITERS]: 'smartrecruiters',
  [GR8PEOPLE]: 'gr8people',
  [LEVER]: 'lever',
  [WORKDAY]: 'workday',
  [SUCCESSFACTORS]: 'successfactors',
  [ICIMS]: 'icims',
};

const atsToUse = computed(() => atsIds[props.atsId]);
</script>

<style lang="less" scoped>
.category-title {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 500;
  color: @primary;
  line-height: 150%;
  padding: 0 8px 12px 8px;

  &.tag {
    color: @primary;
  }

  &.ats {
    color: @basic-green;
  }
}

.icon-container {
  width: 16px;
  height: 16px;

  :deep(svg) {
    width: 100%;
    height: 100%;
  }
}
</style>
